import { Pagination, StatusMessageResponse } from '@shared/models';

export interface FetchPatientListResponse extends StatusMessageResponse {
  patient_list: PatientListItemResponse[];
  pagination: Pagination;
}

export interface PatientListItemResponse {
  id: number;
  fullname: string;
  tutor_name: string;
  id_card: number;
  id_number: number;
  email: string;
  phone_number: number;
  pathologies: PatientPathology[];
  status: 'active' | 'inactive';
  prepaid: string;
}
export interface PatientPathology {
  id: number;
  name: string;
}
